import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseUserGeneralProgress } from '@/api/responses/userGeneralProgresses'

export namespace UserGeneralProgressesApi {
  /**
   * 次に演習する学習レベル取得
   *
   * @param curriculumUnitId 単元ID
   * @returns 次に演習する学習レベル
   */
  export async function getNextLearning(curriculumUnitId: number): Promise<ApiResponseUserGeneralProgress> {
    return await ApiBase.get(`userGeneralProgresses/${curriculumUnitId}/nextLearning`)
  }
}
